import { formatCurrency } from '@travelwin/core';

import { useLocaleUtils } from '../../../hooks/useLocaleUtils';

type Props = {
  price: number;
  currencyAlias: string;
};

export const Price = ({ price, currencyAlias }: Props) => {
  const { currentLocale } = useLocaleUtils();
  const formattedPrice = formatCurrency(currentLocale, currencyAlias, price);

  return formattedPrice;
};
